export default __webpack_public_path__ + "static/media/json.0f9ed04d.svg";